import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import { mapTradeType } from '../../../../axios/dictionaries';
import { CustomCol, CustomRow } from '../../../../components/Custom';
import DetailTitle from '../../../../components/DetailTitle';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { fetchPlatformRecordYlSharingPayOrderSummaryDataOrderGet } from '../../../../services/platformAccountingRecord';
import { findDict, formatTime } from '../../../../utils';

const YLSharingPayOrderSummaryDataOrderDetail = (props) => {

    const [visible, setVisible] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        post(id)
    }
    const close = () => {
        setVisible(false)
    }
   
    const post = (id) => {
        fetchPlatformRecordYlSharingPayOrderSummaryDataOrderGet({id}).then(res => {
            setDetailData(res)
        })
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="汇总数据订单明细数据详情" 
            width={950} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }}>
                <div className="custom" >
                    <DetailTitle title="基础信息" />
                    <CustomRow >
                        <CustomCol label="收单方代码">
                            <span style={{ paddingLeft:6 }}>{detailData.acquirerCode}</span>
                        </CustomCol>
                        <CustomCol label="退货中金额">
                            <span style={{ paddingLeft:6 }}>{detailData.amountInReturn}</span>
                        </CustomCol>
                        <CustomCol label="已划付金额">
                            <span style={{ paddingLeft:6 }}>{detailData.transferredAmount}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="卡类型">
                            <span style={{ paddingLeft:6 }}>{detailData.cardType}</span>
                        </CustomCol>
                    
                        <CustomCol label="清算收单代码">
                            <span style={{ paddingLeft:6 }}>{detailData.clearingAcquirerCode}</span>
                        </CustomCol>
                    
                        <CustomCol label="创建时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.createTime)}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="客户号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.customerNumber}</span>
                        </CustomCol>
                        <CustomCol label="分账金额">
                            <span style={{ paddingLeft:6 }}>{detailData.dividedAmount}</span>
                        </CustomCol>
                       
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="企业用户号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.enterpriseUserNumber}</span>
                        </CustomCol>
                        <CustomCol label="结算商户编号">
                            <span style={{ paddingLeft:6 }}>{detailData.settlementMerchantNumber}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        
                        <CustomCol label="商户名称" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.merchantName}</span>
                        </CustomCol>
                        <CustomCol label="商户集团编号">
                            <span style={{ paddingLeft:6 }}>{detailData.merchantGroupNumber}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="机构编号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.orgNo}</span>
                        </CustomCol>
                        <CustomCol label="清算日期">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.liquidationDate)}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="商户订单号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.merchantOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="终端号">
                            <span style={{ paddingLeft:6 }}>{detailData.terminalNumber}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="原交易参考号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.originalReferenceNumber}</span>
                        </CustomCol>
                        <CustomCol label="原交易金额">
                            <span style={{ paddingLeft:6 }}>{detailData.originalTradeAmount}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="参考号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.referenceNumber}</span>
                        </CustomCol>
                        
                        <CustomCol label="原交易日期">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.originalTradingTime)}</span>
                        </CustomCol>
                       
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="备注信息">
                            <span style={{ paddingLeft:6 }}>{detailData.remark}</span>
                        </CustomCol>
                        <CustomCol label="可退货金额">
                            <span style={{ paddingLeft:6 }}>{detailData.returnableAmount}</span>
                        </CustomCol>
                        <CustomCol label="已退货金额">
                            <span style={{ paddingLeft:6 }}>{detailData.returnedAmount}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="流水号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.serialNumber}</span>
                        </CustomCol>
                        <CustomCol label="手续费">
                            <span style={{ paddingLeft:6 }}>{detailData.serviceCharge}</span>
                        </CustomCol>
                      
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="银商订单号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.silverMerchantOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="挂账流水标记">
                            <span style={{ paddingLeft:6 }}>{detailData.standingBookMark}</span>
                        </CustomCol>
                       
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="交易金额">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeAmount}</span>
                        </CustomCol>
                        <CustomCol label="交易净额">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeNetAmount}</span>
                        </CustomCol>
                        <CustomCol label="交易类型">
                            <span style={{ paddingLeft:6 }}>{findDict(mapTradeType, detailData.tradeType).title }</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="交易时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.tradingTime)}</span>
                        </CustomCol>
                        <CustomCol label="划付中金额">
                            <span style={{ paddingLeft:6 }}>{detailData.transferInProgressAmount}</span>
                        </CustomCol>
                        <CustomCol label="可划付金额">
                            <span style={{ paddingLeft:6 }}>{detailData.transferableAmount}</span>
                        </CustomCol>
                    </CustomRow>
                   
                    
                </div>
            </ModalScrollContainer>
        </Modal>
    )

}

export default YLSharingPayOrderSummaryDataOrderDetail


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLSharingPayOrderSummaryList/components/YLSharingPayOrderSummaryDataOrderDetailModal.jsx